//Job
export const BASE_JOBS = "/api/job";

//Job
export const BASE_JOBS_CONADIDATE_STATE = "/api/jobcandidatestage";

//Job
export const BASE_JOB_TIMELINE = "/api/jobtimeline";

//Form
export const BASE_FORMS = "/api/forms";

//Document
export const BASE_DOCUMENTS = "/api/documents";

//Document
export const BASE_USER_GROUP = "/api/usergroup";

// Create Job Custom View
export const BASE_JOB_CUSTOM_VIEW = "/api/job";

// User
export const BASE_USER = "/api/user";

// TOS
export const BASE_TOS = "/api/tos";

// Pre-Offer Verification
export const BASE_PRE_OFFER_VERIFICATION = "/api/pre-offer-verification";

// Conditional Offer
export const BASE_CONDITIONAL_OFFER = "/api/conditional-offer";

// Offer Status
export const BASE_OFFER_STATUS = "/api/offerstatus";

// pre assessment
export const BASE_PRE_ASSESSMENT = "/api/pre-assessment";
